import React from 'react';
import { IonRouterLink } from '@ionic/react';

import { ButtonWrapper, RouterLink } from './styles';

interface LinkProps {
  route?: string;
  button?: boolean;
  isHidden?: boolean;
  routerDirection?: 'back' | 'forward' | 'root' | undefined;
  testId?: string;
  [x: string]: any;
}

const Link: React.FC<LinkProps> = ({
  route,
  isHidden,
  children,
  testId = 'link',
  button = false,
  routerDirection,
  ...rest
}) => {
  if (isHidden) return null;
  const linkComponent = routerDirection ? (
    <IonRouterLink data-testid={testId} routerLink={route} routerDirection={routerDirection} {...rest}>
      {children}
    </IonRouterLink>
  ) : route ? (
    <RouterLink data-testid={testId} to={route} {...rest}>
      {children}
    </RouterLink>
  ) : (
    <div {...rest} data-testid={testId}>
      {children}
    </div>
  );

  return button ? <ButtonWrapper>{linkComponent}</ButtonWrapper> : <>{linkComponent}</>;
};

export default Link;
